import {
  ErrorDisplay,
  FormCheckbox,
  FormHub,
  FormTextField,
  StyledDialog,
  SubmitButton,
  useFormEvents,
} from '@lib/common';
import {
  FormStatus,
  GuestSurvey,
  GuestSurveyForms,
  UpdateGuestSurveyOutreachRequest,
} from '@lib/state';
import { DialogContent, Grid } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';

interface Props {
  guestSurvey: GuestSurvey;
  open: boolean;
  onClose: () => void;
  onSubmit: (guestSurvey: UpdateGuestSurveyOutreachRequest) => void;
}

export function SurveyUpdateModal({ guestSurvey, open, onClose, onSubmit }: Props) {
  const [{ status, error }, reset] = useFormEvents(GuestSurveyForms.UpdateGuestSurvey);

  const defaultValues: UpdateGuestSurveyOutreachRequest = useMemo(
    () => ({
      guestSurveyId: guestSurvey.id,
      outreachCompleted: guestSurvey.outreachCompleted,
    }),
    [guestSurvey]
  );

  useEffect(() => {
    if (status === FormStatus.Success) {
      onClose();
      reset();
    }
  }, [status, onClose, reset]);

  return (
    <StyledDialog
      title={`Update Outreach for ${guestSurvey.recordNumber}`}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogContent>
        {status === FormStatus.Error && <ErrorDisplay error={error} onCancel={reset} />}
        <FormHub onSubmit={onSubmit} formOptions={{ defaultValues }}>
          <Grid container>
            <FormTextField name="guestSurveyId" style={{ display: 'none' }} disabled />
            <Grid item sm={6} md={12}>
              <FormTextField name="outreachNotes" label="Outreach Notes" fullWidth />
            </Grid>
            <Grid item sm={6} md={12}>
              <FormCheckbox name="outreachCompleted" label="Outreach Completed" />
            </Grid>
            <SubmitButton
              variant="contained"
              color="secondary"
              fullWidth
              pending={status === FormStatus.Pending}
              disabled={status === FormStatus.Pending}
              data-testid="updateOutreachSubmitButton"
            >
              Submit
            </SubmitButton>
          </Grid>
        </FormHub>
      </DialogContent>
    </StyledDialog>
  );
}
